//是否有计划书
import {getProductList} from '@/api/insurance/product'

export function isShowPlan(insureType) {
	return [6, 8, 13, 16, 18, 19, 22, 3, 12].includes(insureType)
}

//是否应用产品中心的详情页
export function isDetailByCenter(insureType) {
	return [].includes(insureType)
}

//是否有职业类别表
export function isHasCategory(insureType) {
	return ![7, 17, 3].includes(insureType)
}

//泛高空
export function isFgk(insureType) {
	return insureType == 6
}

export function isFgkDianti(insureType) {
	return insureType == 21 || insureType == 99 || insureType == 48
}

const fgkCommon = [275, 277]
const fgkZungui = [276, 278]

//泛高空普通版
export function isFgkCommon(productId) {
	return fgkCommon.includes(parseInt(productId))
}

export function isFgkCommonYear(productId) {
	return productId == 295
}

//泛高空尊贵版
export function isFgkZungui(productId) {
	return fgkZungui.includes(parseInt(productId))
}

//计划书获取id
export function getPlanProductId(productId) {
	if (isFgkCommon(productId)) {
		return fgkCommon[0]
	}
	if (isFgkZungui(productId)) {
		return fgkZungui[0]
	}
	return productId
}

//泛高空钢结构尊贵版
export function isFgkGangZungui(productId) {
	return productId == 256
}

//泛高空钢结构低伤残方案-- 普通版
export function isFgkGangCommon(productId) {
	return productId == 259
}

//泛高空钢结构！
export function isFgkGang(productId) {
	return isFgkGangZungui(productId) || isFgkGangCommon(productId)
}

//泛高空门窗
export function isFgkDoor(productId) {
	return productId == 364 || productId == 363
}

//泛高空光伏
export function isFgkGuangfu(productId) {
	return productId == 267 || productId == 268 || productId == 283 || productId == 284
}

export function isFgkGuangfuDiqu(productId) {
	return productId == 283 || productId == 284
}

export function isFgkGuangfuQuanguo(productId) {
	return productId == 267 || productId == 268
}

//判断是否为光伏或者门窗 普通版本
export function isFgkGuangfuDoorCustom(productId) {
	return productId == 267 || productId == 283 || productId == 261
}

//国寿财
export function isGuoShouCai(insureType) {
	return insureType == 8
}

//安责
export function isAnZeJianzhu(insureType) {
	return insureType == 12
}

export function isAnZeStandard(productId) {
	return productId == 298 || productId == 300 || productId == 302
}

export function isAnZeCommon(productId) {
	return productId == 298 || productId == 299
}

export function isAnZeGang(productId) {
	return productId == 300 || productId == 301
}

export function isAnZePower(productId) {
	return productId == 302 || productId == 303
}

export function isAnZeDianTi(insureType) {
	return insureType == 18
}

//亚太
export function isYt29(productId) {
	return productId == 29
}

export function isYt30(productId) {
	return productId == 30
}

//判断家电
export function isJiaDianLong(insureType) {
	return insureType == 17
}

export function isJiaDian(insureType) {
	return insureType == 7 || insureType == 17
}

//美亚
export function isMeiYa(insureType) {
	return insureType == 13
}

//美亚 B款
export function isMeiYaB(insureType, productId) {
	return insureType == 13 && productId == 213
}

//美亚 C款
export function isMeiYaC(insureType, productId) {
	return insureType == 13 && (productId == 304 || productId == 305)
}

//新市民制造业
export function isXsmZhiZao(insureType) {
	return insureType == 19
}

//新市民建筑行业
export function isXsmJianzhu(insureType) {
	return insureType == 16
}

//安责1-5类
export function isAnZe15(insureType) {
	return insureType == 22
}

//判断是否为安责产品，需要各种条件设置，比如5万。。。this.insureType === 12 || this.insureType === 18
export function isAnZeProduct(insureType) {
	return [12, 18, 22].includes(insureType)
}

//阳光运输
export function isXsmYunShu(insureType) {
	return insureType == 23
}

//上海太保泛高空和电梯隐藏对公发票信息
export function isFgkZhuanpiao(insureType) {
	return insureType == 6 || insureType == 21
}

//投保期限为1年的！！！！
//家电雇主险和  平安家居/充电桩安装运维工雇主险
export function isJiaDianOneYear(insureType) {
	return insureType == 17 || insureType == 3
}

//人保
export function isRenBao(insureType) {
	return insureType == 29 || insureType == 36
}

//引流只能投新市民
export const xsmYinLiuList = [
	{
		insureType: 16,
		productId: 238,
	},
	{
		insureType: 19,
		productId: 273,
	},
]

//门窗261, 260  和光伏 257, 258
export function isGetGaiZhangProductId(productId, planType) {
	if (isFgkDoor(productId)) {
		return planType == '0' ? 261 : 260
	}
	if (isFgkGuangfuDiqu(productId)) {
		return planType == '0' ? 283 : 284
	}
	if (isFgkGuangfuQuanguo(productId)) {
		return planType == '0' ? 267 : 268
	}
}

let productListData = []

//通过产品数据获取list数据
export function getListData() {
	return new Promise((resolve, reject) => {
		if (productListData.length > 0) {
			resolve(productListData)
		} else {
			getProductList()
				.then((response = {}) => {
					let {code = -1, data = []} = response.data
					if (code === 0) {
						productListData = data
						resolve(data)
					} else {
						reject()
					}
				})
				.catch((error) => {
					reject(error)
				})
		}
	})
}

//判断当前id是否可用
export function isProductIdEnable(productId, insureType) {
	return new Promise(async (resolve, reject) => {
		if (typeof productId === 'string') {
			productId = parseInt(productId)
		}
		if (typeof insureType === 'string') {
			insureType = parseInt(insureType)
		}
		if (productListData.length === 0) {
			await getListData().catch(() => {
				reject()
			})
		}
		let tempWaiIndex = productListData.findIndex(({id, productPlanRelationList = [], insureType: insureTypeNei}) => {
			if (insureType === insureTypeNei) {
				if (productPlanRelationList.length > 0) {
					let tempIndex = productPlanRelationList.findIndex(
						({planId: productIdNei}) => productIdNei + '' === productId + '',
					)
					return tempIndex !== -1
				} else {
					return id + '' === productId + ''
				}
			}
		})
		if (tempWaiIndex !== -1) {
			resolve()
		} else {
			reject()
		}
	})
}
